type PwaConfig = {
  url: string,
  title: string,
  description: string,
  accentColor: string,
  icon: string,
};

export function setupProgressiveWebApp(config: PwaConfig) {
  const manifest = JSON.stringify({
    id: '/',
    name: config.title,
    short_name: config.title,
    start_url: config.url,
    background_color: "#fff",
    theme_color: config.accentColor,
    description: config.description,
    display: "standalone",
    display_override: ["standalone", "fullscreen", "minimal-ui", "browser"],
    icons: [
      { src: config.icon, sizes: "512x512", type: "image/png" },
    ]
  });

  const blob = new Blob([manifest], { type: 'application/json' });
  const manifestURL = URL.createObjectURL(blob);
  document.querySelector('[data-theme-manifest]').setAttribute('href', manifestURL);
}
